import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import ProductCard from './ProductCard';
import './RelatedProductsSection.css';

const RelatedProductsSection = ({
  products,
  onAddToCart,
  onSeeMore,
  className = '',
  ...rest
}) => {
  const [expanded, setExpanded] = useState(false);
  const productsPerRow = 4;
  const initialRows = 1;
  
  const displayedProducts = expanded 
    ? products 
    : products.slice(0, productsPerRow * initialRows);

  const hasMoreProducts = products.length > productsPerRow * initialRows;

  const handleToggleExpand = () => {
    setExpanded(!expanded);
    if (onSeeMore) {
      onSeeMore(!expanded);
    }
  };

  return (
    <section className={`related-products-section ${className}`.trim()} data-expanded={expanded} {...rest}>
      <div className="related-products-section__header">
        <i className="fas fa-shopping-bag related-products-section__icon" aria-hidden="true"></i>
        <h2>Related Products</h2>
      </div>
      
      <div className="related-products-section__grid">
        {displayedProducts.map((product) => {
          const titleUrl = product.title_url || product.name || product.title || product.short_title || '';
          const productId = product.product_id || product.id;
          const productDetailsUrl = `/products_details/${encodeURIComponent(titleUrl)}/${productId}`;
          return (
            <ProductCard
              key={productId}
              productId={productId}
              image={product.image || product.image_name}
              name={product.name || product.title || product.short_title}
              description={product.description || product.type}
              price={product.price}
              priceLabel={product.price_label || 'INR'}
              onAddToCart={onAddToCart}
              isInCart={product.isInCart || false}
              detailsUrl={productDetailsUrl}
            />
          );
        })}
      </div>
      
      {hasMoreProducts && (
        <div className="related-products-section__actions">
          <button
            type="button"
            className="related-products-section__see-more"
            onClick={handleToggleExpand}
          >
            {expanded ? 'Show Less' : 'See More'}
            <i className={`fas fa-chevron-${expanded ? 'up' : 'down'}`} aria-hidden="true"></i>
          </button>
        </div>
      )}
    </section>
  );
};

RelatedProductsSection.propTypes = {
  products: PropTypes.arrayOf(
    PropTypes.shape({
      product_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      image: PropTypes.string,
      name: PropTypes.string,
      description: PropTypes.string,
      price: PropTypes.string,
      price_label: PropTypes.string,
    })
  ).isRequired,
  onAddToCart: PropTypes.func,
  onSeeMore: PropTypes.func,
  className: PropTypes.string,
};

RelatedProductsSection.defaultProps = {
  onAddToCart: () => {},
  onSeeMore: undefined,
  className: '',
};

export default RelatedProductsSection;

